<div [formGroup]="form" class="grid grid-cols-1 md:grid-cols-2 gap-6">

    <!-- First Address Line -->
    <mat-form-field appearance="fill" class="md:col-span-2">
        <mat-label>First Address Line</mat-label>
        <input matInput formControlName="firstAddressLine" required>
        @if (form.get('firstAddressLine')?.hasError('required')) {
        <mat-error>First address line is required</mat-error>
        }
    </mat-form-field>

    <!-- Second Address Line -->
    <mat-form-field appearance="fill" class="md:col-span-2">
        <mat-label>Second Address Line</mat-label>
        <input matInput formControlName="secondAddressLine">
    </mat-form-field>

    <!-- Locality -->
    <mat-form-field appearance="fill">
        <mat-label>City / Locality</mat-label>
        <input matInput formControlName="locality" required>
        @if (form.get('locality')?.hasError('required')) {
        <mat-error>Locality is required</mat-error>
        }
    </mat-form-field>

    <!-- Post Code -->
    <mat-form-field appearance="fill">
        <mat-label>Post Code</mat-label>
        <input matInput formControlName="postCode" required>
        @if (form.get('postCode')?.hasError('required')) {
        <mat-error>Post code is required</mat-error>
        }
    </mat-form-field>

    <!-- Region -->
    <mat-form-field appearance="fill">
        <mat-label>State / Region</mat-label>
        <input matInput formControlName="region">
    </mat-form-field>

    <!-- Country Code -->
    <mat-form-field appearance="fill">
        <mat-label>Country Code</mat-label>
        <input matInput formControlName="countryCode" required>
        @if (form.get('countryCode')?.hasError('required')) {
        <mat-error>Country code is required</mat-error>
        }
    </mat-form-field>

    <!-- Latitude -->
    <mat-form-field appearance="fill">
        <mat-label>Latitude</mat-label>
        <input matInput type="number" formControlName="latitude">
    </mat-form-field>

    <!-- Longitude -->
    <mat-form-field appearance="fill">
        <mat-label>Longitude</mat-label>
        <input matInput type="number" formControlName="longitude">
    </mat-form-field>

</div>